const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/sms-meldinger/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/sms-meldinger/")({
  loader: async () => {
    const result = await routeLoaderApiClient["sms-messages"].$get();
    if (result.ok === false) {
      throw new Error("Failed to fetch messages");
    }
    return {
      messages: await result.json()
    };
  },
  head: () => ({
    meta: [{
      title: "SMS-meldinger | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});